export default __webpack_public_path__ + "static/media/background_question_mark.e9db01fe.svg";